const UTM_KEYS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_adgroup',
	'utm_term',
	'utm_id'
];

function apply_utm(marketingConsent = false){
	const params = new URLSearchParams(window.location.search);

	for(const key of UTM_KEYS){
		let value = sessionStorage.getItem('ma_' + key);

		if(!value){
			value = params.get(key);

			if(value && marketingConsent){
				sessionStorage.setItem('ma_' + key, value);
			}
		}

		if(!value) continue;

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			event: 'ma_' + key,
			utm_param: { key, value }
		});

		document.querySelectorAll('.' + key).forEach(el => {
			el.value = value;
		});
	}
}

function clear_utm(){
	UTM_KEYS.forEach(key => sessionStorage.removeItem('ma_' + key));
}

export { apply_utm, clear_utm };